import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useStats } from '../contexts/StatsContext';
import './Navbar.css';

const Navbar = () => {
  const { usuario, perfil, logout } = useAuth();
  const { getTotalAcertos, getTotalErros, getTaxaAcerto } = useStats();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuAberto, setMenuAberto] = useState(false);
  const [userMenuAberto, setUserMenuAberto] = useState(false);

  const pacote = perfil?.pacote || 1;

const links = [
  { to: '/minha-jornada', label: 'Minha Jornada', icone: '🧭' },
  { to: '/meus-cursos', label: 'Meus Cursos', icone: '🎓' },
  { to: '/', label: 'Início', icone: '🏠' },
  { to: '/materias', label: 'Matérias', icone: '📚' },
  { to: '/revisao', label: 'Revisão', icone: '🔄' },
  { to: '/dashboard', label: 'Dashboard', icone: '📊' },
  { to: '/ranking', label: 'Ranking', icone: '🏆' },
  ...(pacote >= 2 ? [{ to: '/simulado', label: 'Simulados / Questões', icone: '🎯' }] : []),
];

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const acertos = getTotalAcertos();
  const erros = getTotalErros();
  const taxa = getTaxaAcerto();

  const avatar = perfil?.avatar || '👤';
  const cor = perfil?.cor || '#2563eb';
  const isAdmin = perfil?.isAdmin === true || perfil?.role === 'admin';

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          <span className="brand-icon">🎓</span>
          <span className="brand-nome">PRUVENX APROVADO</span>
        </Link>

        <div className={`navbar-links ${menuAberto ? 'aberto' : ''}`}>
          {links.map(l => (
            <Link
              key={l.to}
              to={l.to}
              className={`nav-link ${location.pathname === l.to ? 'ativo' : ''}`}
              onClick={() => setMenuAberto(false)}
            >
              <span>{l.icone}</span>
              <span>{l.label}</span>
            </Link>
          ))}
        </div>

        <div className="navbar-right">
          <div className="navbar-stats">
            <div className="ns-item acerto">
              <span>✓</span>
              <span>{acertos}</span>
            </div>
            <div className="ns-item erro">
              <span>✗</span>
              <span>{erros}</span>
            </div>
            <div className="ns-item taxa">
              <span>{taxa}%</span>
            </div>
          </div>

          <div className="user-menu-wrapper">
            <button
              className="user-btn"
              onClick={() => setUserMenuAberto(!userMenuAberto)}
              style={{ '--cor': cor }}
            >
              <span className="user-avatar">{avatar}</span>
              <span className="user-nome">{perfil?.nome || 'Usuário'}</span>
              <span className="user-chevron">▾</span>
            </button>

            {userMenuAberto && (
              <div className="user-dropdown">
                <div className="ud-header">
                  <span className="ud-avatar">{avatar}</span>
                  <div>
                    <div className="ud-nome">{perfil?.nome}</div>
                    <div className="ud-email">{usuario?.email}</div>
                    {isAdmin && (
                      <span style={{ fontSize: '0.7rem', background: '#fef3c7', color: '#d97706', padding: '2px 8px', borderRadius: 6, fontWeight: 700 }}>
                        👑 Admin
                      </span>
                    )}
                  </div>
                </div>
                <div className="ud-divider" />
                {isAdmin && (
                  <Link to="/admin" className="ud-item" onClick={() => setUserMenuAberto(false)}>
                    🛠️ Painel Admin
                  </Link>
                )}
                <Link to="/configuracoes" className="ud-item" onClick={() => setUserMenuAberto(false)}>
                  ⚙️ Configurações
                </Link>
                <Link to="/perfil" className="ud-item" onClick={() => setUserMenuAberto(false)}>👤 Meu Perfil</Link>
                <button className="ud-item ud-logout" onClick={handleLogout}>
                  🚪 Sair
                </button>
              </div>
            )}
          </div>

          <button
            className="hamburger"
            onClick={() => setMenuAberto(!menuAberto)}
            aria-label="Menu"
          >
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
